export default {
    // nome app
    "SalesPaddy":"SalesPaddy",
    // tabs
    "Home":"Home",
    "Salons":"Salons",
    "Users":"Users",
    "Dealers":"Dealers",
    "Digital Inventory":"Digital Inventory",
    // filtro nelle tabelle
    "Applica filtro":"Apply filter",
    "filtro...":"filter...",
    // azioni salon
    "Crea":"Create",
    // salons: tabella e form
    "Ragione Sociale":"Company",
    "Insegna":"Signboard",
    "Autocomplete":"Autocomplete",
    "Indirizzo":"Street",
    "Città":"City",
    "Cap":"Postalcode",
    "Paese":"State",
    "Provincia":"State",
    "Nazione":"Country",
    "Email":"Email",
    "Telefono":"Phone",
    "Web":"Web",
    "Attivo":"Active",
    "Alert":"Alert",
    "Tipo":"Type",
    "Latitude":"Latitude",
    "Longitude":"Longitude",
    "Latitude2":"Latitude2",
    "Longitude2":"Longitude2",
    // sezioni form
    "Dati principali":"Primary Informations",
    "Sede Legale":"Shipping Address",
    "Contatto":"Contact",
    "Dati qualitativi":"Qualitative Informations",
    // users: tabella e form
    "Dealer":"Dealer",
    "Codice X3":"ERP Code",
    "Nome":"Firstname",
    "Cognome":"Lastname",
    "Lingua":"Language",
    "Privilegi":"Privileges",
    // sezioni form
    "Dati Anagrafici":"Anagrafic Informations",
    //
    "Codice Dealer":"Dealer Code",
    "Inserire il codice":"Insert the code",
    "Codice Dealer non trovato":"Dealer Code not found",
    // mappa
    "Mappa Saloni":"Salons Map",
    "Saloni visualizzati:":"In map Salons:",
    "Leads":"Leads",
    "Saloni":"Salons",
    "Tipo Visualizzazione:":"View type:",
    "Heatmap":"Heatmap",
    "Markers":"Markers",
    "Scheda Lead":"Lead Info",
    "Scheda Cliente":"Salon Info",
    "Google Maps":"Google Maps",
    "Risultato ricerca:":"Search results:",
    "Corrispondenze trovate:":"Matches found:",
    "Valutazione:":"Evaluation:",
    "Recensioni:":"Reviews:",
    "x":"x",
    // digital inventory
    "official_site__label":"is there an official country brand site?",
    "official_ecommerce__label":"is this site an ecommerce ?",
    "official_domain__label":"what is the domain* name?",
    "official_domain__tip":"*Web domains are the www address naming under which you can retrieve the website on the internet (URL).A web domain is composed of 2 parts: a naming suffix, a dot extension acronym ( e.g: davines.com)",
    "multibrand_website__label":"does your company / group directly own a multi-brand informative website which includes our products?",
    "multibrand_domain__label":"what is the domain* name?",
    "multibrand_ecommerce__label":"does your company / group directly own a multi-brand ecommerce which sells our products?",
    "multibrand_ecommerce_domain__label":"what is the domain* name?",
    "marketplaces__label":"do you directly sell to end users through some marketplaces*?",
    "marketplaces__tip":"An online marketplace is a website or mobile application that connects buyers and sellers (e.g: Ebay, Amazon)",
    "marketplaces_list__label":"please list all marketplaces:",
    "digitally_selling_branded__label":"do you directly or indirectly sell our products through other e-commerce websites in the country? Indicate ownership",
    "relevant_ecommerce__label":"if yes, please list all relevant e-commerce websites:",
    "Domain":"Domain",
    "Owned by":"Owned by",
    "Third party":"Third party e-retailer",
    "Salon owned":"Salon/store owned",
    "WEBSITES":"WEBSITES",
    // domain again...
    "domains__label":"please list all domains associated with the brand in your country",
    "domains__tip":"please list all the main or local domain extension ( e.g: skinregimen.cn , skinregimen.com.cn)",
    "Your property":"Your property",
    "Davines property":"Davines property",
    "DOMAINS":"DOMAINS",
    "social__label":"please list all social media pages/ account/ groups associated with the brand in your country directly managed",
    "Social page name":"Name of the page",
    "Social media":"Social media",
    "Link":"Link",
    "SOCIAL MEDIA":"SOCIAL MEDIA",

}